import React from "react";
import { Paper, Typography, Box, Grid } from "@mui/material";

export default function CriteriaDefinitions() {
    const criteria = [
        {
            title: "Student Interaction",
            description:
                "1-3: Rarely interacts and remains passive during sessions. 4–6: Participates occasionally but lacks consistency. 7–8: Engages actively in discussions, asks questions, and contributes well. 9–10: Initiates discussions, shares ideas confidently, and promotes teamwork.",
        },
        {
            title: "Punctuality",
            description:
                "1-3: Frequently late or misses deadlines without valid reasons. 4–6: Occasionally late or delayed submissions. 7–8: Usually punctual with minor delays. 9–10: Always on time and consistently meets deadlines.",
        },
        {
            title: "Extracurricular Activities:",
            description:
                "1–3: Shows little or no participation in activities. 4–6: Participates occasionally with moderate interest. 7–8: Actively takes part and performs well. 9–10: Consistently participates, leads, and excels in activities.",
        },
        {
            title: "Attendance:",
            description:
                "1–3: Frequently absent without reason. 4–6: Acceptable attendance with occasional delays. 7–8: Regular attendance and punctuality. 9–10: Excellent attendance record, always on time.",
        },
    ];

    return (
        <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 2, mt: 6 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
                Criteria Definitions
            </Typography>
            <Grid container spacing={2}>
                {criteria.map((item, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                        <Box
                            sx={{
                                backgroundColor: "#f9fafb",
                                borderRadius: 2,
                                p: 2,
                                border: "1px solid #e0e0e0",
                                height: "100%",
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                fontWeight="bold"
                                sx={{ mb: 0.5, color: "#333" }}
                            >
                                {item.title}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ color: "#555", lineHeight: 1.5 }}
                            >
                                {item.description}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
}
